import React from "react";

// Components
import Button from "../Button/Button";

export default class MembersTableFiltersButton extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      selected: false,
    };
  }

  render() {
    return (
      <Button key={this.props.field} onClick={(e: MouseEvent) => this.handleClick(e, this.props.field, this.props.value)} className={this.state.selected && "button--selected"}>
        <div />
        {this.props.text}
      </Button>
    );
  }

  componentDidMount() {
    const { activeFilters } = this.props;
    if (activeFilters[this.props.field] && activeFilters[this.props.field].split(",").includes(this.props.value)) {
      this.setState({ selected: true });
    }
  }

  handleClick = (e: any, key: string, value: string | number) => {
    const selected = !this.state.selected;
    this.setState({ selected });

    this.props.handleClick(e, key, value, selected);
  };
}
